import { applicationContextActionCreator } from '../store/actions';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import ServiceBase from './ServiceBase';

class CustomerCodingEventService extends ServiceBase {
    async getEvents(queryItems) {
        var result = await this.requestJson({
            url: '/api/cust/codingevent/query',
            method: "GET",
            data: queryItems
        });

        return result;
    }

    async getEvent(id) {
        var result = await this.requestJson({
            url: `/api/cust/codingevent/${id}`,
            method: "GET"
        });

        return result;
    }

    async updateCustomerPriority(priorityId, codingEventId) {
        var result = await this.requestJson({
            url: `/api/cust/codingevent/priority`,
            method: "POST",
            data: { "customerPriorityId": priorityId, "codingEventId": codingEventId}
        });

        return result;
    }

    async getMetrics(id) {
        var result = await this.requestJson({
            url: `/api/cust/codingevent/metrics`,
            method: "GET"
        });

        return result;
    }

    async getCustomerRef(showParentAccounts = true, showChildAccounts = true) {
        var result = await this.requestJson({
            url: `api/admin/account/custref`,
            method: "POST",
            data: { "showParentAccounts": showParentAccounts, "showChildAccounts": showChildAccounts }
        })

        return result;
    }

    async getCodingEvents(accountIds, dateFrom, dateTo) {
        const values = { "accountIds": accountIds, "dateFrom": new Date(dateFrom), "dateTo": new Date(dateTo) };
        var result = await this.requestJson({
            url: `/api/cust/codingevent/reports/history`,
            method: "POST",
            data: values
        });
        return result;
    }

    async assessmentQAReport(accountIds, dateFrom, dateTo, selectedWorksheets, selectedLocators) {
        const values = {
            "accountIds": accountIds,
            "dateFrom": new Date(dateFrom),
            "dateTo": new Date(dateTo),
            "locators": selectedLocators,
            "worksheetIds": selectedWorksheets
        };
        var result = await this.requestJson({
            url: `/api/cust/reports/assessment/qa`,
            method: "POST",
            data: values
        });
        return result;
    }

    //url: `/api/admin/codingevent/${file.codingEventID}/file/${file.id}`
    async getFile(codingEventId, id) {

        let callResponse = undefined;

        let webapi = `api/cust/codingevent/${codingEventId}/file/${id}`;
        const token = this.getToken();
        callResponse = fetch(webapi,
                {
                    method: 'GET',
                    headers: {
                        responseType: 'blob',
                        authorization: token
                    }
                })
            .then(response => response.blob())
            .then(blob => {
                let objUrl = URL.createObjectURL(blob);
                return { result: true, model: objUrl };
            }) ;

        return callResponse;
    }

    async createFile(file, codingEventId) {
        var result = await this.sendFormData({
            url: `/api/cust/codingevent/${codingEventId}/file/`,
            method: "POST",
            data: file
        });

        return result;
    }

    async getWorksheet(id) {
        var result = await this.requestJson({
            url: `/api/cust/worksheet/${id}`,
            method: "GET"
        });

        return result;
    }

    async deleteFile(fileId, codingEventId) {
        var result = await this.requestJson({
            url: `/api/cust/codingevent/${codingEventId}/file/${fileId}`,
            method: "DELETE"
        })
        return result;
    }

    //async addNote(note, codingEventId) {
    //    var result = await this.requestJson({
    //        url: `/api/admin/codingevent/${codingEventId}/note`,
    //        method: "POST",
    //        data: note
    //    });
    //    return result;
    //}

    //async deleteNote(noteId, codingEventId) {
    //    var result = await this.requestJson({
    //        url: `/api/admin/codingevent/${codingEventId}/note/${noteId}`,
    //        method: "DELETE"
    //    })
    //    return result;
    //}

    //async saveEvent(codingEvent) {
    //    var result = await this.requestJson({
    //        url: `/api/admin/codingevent/${codingEvent.id}`,
    //        method: "PUT",
    //        data: codingEvent
    //    });
    //    return result;
    //}

    //async bulkSaveEvents(codingEvents) {
    //    var result = await this.requestJson({
    //        url: '/api/admin/codingevents',
    //        method: "PUT",
    //        data: codingEvents
    //    });

    //    return result;
    //}

    async createCodingEvent(event) { //sendFormData
        var result = await this.requestJson({
            url: "/api/cust/codingevent/",
            method: "POST",
            data: event
        });
        return result;
    }

    async getCreateViewModel() {
        var result = await this.requestJson({
            url: '/api/cust/codingevent/import',
            method: "GET"
        });
        return result;
    }
}

export default CustomerCodingEventService